<template>
    <footer class="page-footer font-small blue">
      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        <p style="color: black;">© 2022 Copyright: </p>
        <a style="color: #0bd2c5;" href="https://www.bayard-consulting.com/">Bayard Consulting Group</a>
        <br>
        <br>
        <p style="color: black;">More on GPC:</p>
        <a style="color: #0bd2c5;" href="https://www.gs1.org/standards/gpc">GPC Standards</a>
      </div>
      <!-- Copyright -->
    </footer>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      date: "Todays date: "
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {

  background-repeat: no-repeat;
  margin: 20px 0px 0px 0px;
  padding: 6px 0px 30px 0px;
}
p {
  color: lightgreen;
  text-align: center;
}
</style>
